import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const ExperimentalComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__experimental"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.57827 0.82827C9.36245 0.612453 9.01255 0.612454 8.79673 0.82827C8.58091 1.04409 8.58091 1.39399 8.79673 1.60981L12.4439 5.25699C12.6597 5.47281 13.0096 5.47281 13.2255 5.25699C13.4413 5.04117 13.4413 4.69127 13.2255 4.47545L9.57827 0.82827ZM11.7926 5.64778L8.40594 2.26111L1.50234 9.1647L1.50235 9.16471L1.50234 9.16473C0.567137 10.0999 0.567137 11.6162 1.50234 12.5514C2.43754 13.4866 3.95381 13.4866 4.88901 12.5514L4.89539 12.545L11.7926 5.64778ZM11.0111 4.86637L9.1875 3.04277L5.01398 7.21629L8.66116 7.21629L11.0111 4.86637Z"
          fill={colorVar}
        />
      </g>
    </svg>
  );
};

export const Experimental = withIcon(ExperimentalComponent);
